import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Industries from './pages/Industries';
import Standards from './pages/Standards';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import WhyAqc from './pages/WhyAqc';
import NotFound from './pages/NotFound';
import Legal from './pages/Legal';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Gallery from './pages/Gallery';
import News from './pages/News';
import { Toaster } from './components/ui/toaster';
import { SettingsProvider } from './lib/settingsContext';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-aqc-cream text-aqc-ink">
      <Header />
      <main id="main" className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <SettingsProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={
              <Shell>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/:slug" element={<ServiceDetail />} />
                  <Route path="/industries" element={<Industries />} />
                  <Route path="/standards" element={<Standards />} />
                  <Route path="/why-us" element={<WhyAqc />} />
                  <Route path="/why-aqc" element={<WhyAqc />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/resources" element={<Resources />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Legal doc="privacy" />} />
                  <Route path="/cookies" element={<Legal doc="cookies" />} />
                  <Route path="/terms" element={<Legal doc="terms" />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Shell>
            } />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </HelmetProvider>
  );
}

export default App;
